<template>
  <div class="relative">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" class="absolute top-0 left-0 w-full h-full animate-spin">
      <path d="M12.8334 6.99992C12.8334 9.94544 10.4456 12.3333 7.50004 12.3333C4.55452 12.3333 2.16671 9.94544 2.16671 6.99992H0.833374C0.833374 10.6818 3.81814 13.6666 7.50004 13.6666C11.1819 13.6666 14.1667 10.6818 14.1667 6.99992C14.1667 3.31802 11.1819 0.333252 7.50004 0.333252V1.66659C10.4456 1.66659 12.8334 4.0544 12.8334 6.99992Z" fill="#00BE90" />
    </svg>
  </div>
</template>
